<script>
  import { Grid, Row, Column } from "carbon-components-svelte";
  import Saos from "saos";

  export let id = "";
  export let title = "";
</script>

<Saos
  animation={"fade-in-bottom 1.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;"}
>
  <section {id}>
    {#if title}
      <Grid>
        <Row>
          <Column><h2>{title}</h2></Column>
        </Row>
      </Grid>
    {/if}
    <slot />
  </section>
</Saos>
<div class="section-spacer" />

<style>
  h2 {
    margin-bottom: var(--cds-spacing-04);
  }

  .section-spacer {
    height: 2rem;
  }

  /* avoid overlapping header by scroll to anchor */
  :target::before {
    content: "";
    display: block;
    height: 60px; /* fixed header height*/
    margin: -60px 0 0; /* negative fixed header height */
  }

  /* ----------------------------------------------
 * Generated by Animista on 2021-3-22 17:22:13
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation fade-in-bottom
 * ----------------------------------------
 */
  @-webkit-keyframes -global-fade-in-bottom {
    0% {
      -webkit-transform: translateY(50px);
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes -global-fade-in-bottom {
    0% {
      -webkit-transform: translateY(50px);
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>
